import { useState, useEffect } from 'react';
import { HostBackend } from '../../Routes/HostBackend.js';
import { GetHeaders } from '../../Components/Admin/Functions/FetchHeaders.js';
import { CountDatas } from '../../Components/Public/Functions/CountDatas.js';
import { FilterOriginsType } from '../../Components/Public/Filters/FilterOriginsType.js';
import { FilterOriginsByType } from '../../Components/Public/Filters/FilterOriginsByType.js';
import { GetDescription } from '../../Components/Public/Functions/GetDescription.js';
import { ScrollTop } from '../../Components/Public/Functions/ScrollTop.js';
/* document */
import { Navigation } from '../../Components/Public/Document/Navigation.js';
import { Header } from '../../Components/Public/Document/Header.js';
import { Footer } from '../../Components/Public/Document/Footer.js';
import { BreadCrumb } from '../../Components/Public/Document/Breadcrumb.js';
import { BreadTags } from '../../Components/Public/Document/BreadTags.js';
import { BlockLogoOrigins } from '../../Components/Public/Logos/BlockLogoOrigins.js';
import { BlockTitleDate1Link0 } from '../../Components/Public/Blocks/BlockTitleDate1Link0.js';
import { BlockOutlink } from '../../Components/Public/Blocks/BlockOutlink.js';
import { BackTop } from '../../Components/Public/Document/BackTop.js';

export const Origins = (props) => {
    const { navParks, ori, att, cha } = props;
    const backend = HostBackend();
    const guest = sessionStorage.getItem('guest');
    const [origins, setOrigins] = useState([]);
    const [body, setBody] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const originsDatas = await fetch(`${backend}/origins`, GetHeaders(guest));
            const origins = await originsDatas.json();
            setOrigins(origins);
            const bodyDatas = await fetch(`${backend}/origins/body`, GetHeaders(guest));
            const body = await bodyDatas.json();
            setBody(body);
        };
        fetchData();
        ScrollTop();
    }, [backend, guest]);
    const attr = CountDatas('origin-attraction', att);
    const char = CountDatas('origin-personnage', cha);
    const originsType = FilterOriginsType(origins);
    const items = GetDescription('origins', { body: body, ori: ori });
    return (
        <div className="origins">
            <Navigation navParks={navParks} />
            <Header />
            <BreadCrumb label="origins" />
            <section className="infos">
                <div className="content">
                    <BreadTags label="origins" datas={originsType} />
                    {originsType.map((el, i) => {
                        const originsByType = FilterOriginsByType(origins, el.otid);
                        const total = originsByType.length;
                        return (
                            <div className="origintype" key={`i-${i}`}>
                                <div className="title-list" id={el.otslug}>{`${el.otname} (${total})`}</div>
                                <div className="list">
                                    {originsByType.map((e, i) => {
                                        const hasAtt = Object.hasOwn(attr, e.oslug);
                                        const hasCha = Object.hasOwn(char, e.oslug);
                                        const legend = `${hasAtt ? attr[e.oslug] : ''} | ${hasCha ? char[e.oslug] : ''}`;
                                        return (
                                            <BlockLogoOrigins item={e} total={legend} key={i} />
                                        )
                                    })}
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div className="description">
                    <BlockTitleDate1Link0 label="origins" items={items} />
                    <p>{items.description}</p>
                    <BlockOutlink items={items} />
                </div>
            </section>
            <BackTop />
            <Footer />
        </div>
    )
}
